<template>
<div>
	<confirm-container :validate-insurance-slip="validateInsuranceSlip" :type="type">
		<div slot-scope="{info}" slot="recognizeInfo">
			<RecognizeInfoForPerson :info="info" v-if="type=='person'"/>
			<RecognizeInfoForCar :info="info" v-if="type=='car'"/>
		</div>
		<div slot-scope="{info}" slot="insuranceSlip">
			<InsuranceSlip :info="info" ref="insuranceSlip" :multiple="true" v-if="type=='person'"/>
		</div>
		<div slot="agree">
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险（2025版A款）条款 (主险).pdf" target="_blank">《平安产险雇主责任保险（2025版A款）条款 (主险)》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加高处（高空）作业扩展保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加高处（高空）作业扩展保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加及时报案保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加及时报案保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加申报工资保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加申报工资保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险责任保险附加伤残赔偿比例保险（2025版A款）条款（附加险）.pdf" target="_blank">《平安产险责任保险附加伤残赔偿比例保险（2025版A款）条款（附加险）》</a>
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加职业类别限定保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加职业类别限定保险（2025版）条款（附加险）》</a>
		</div>
	</confirm-container>
</div>
</template>
<script>
import ConfirmContainer from '@/pages/haierProduct/components/common/ConfirmContainer'
import RecognizeInfoForPerson from './person/RecognizeInfo'
import RecognizeInfoForCar from './car/RecognizeInfo'
import InsuranceSlip from './person/insuranceSlip'
export default {
	components:{ 
		ConfirmContainer,
		RecognizeInfoForPerson,
		RecognizeInfoForCar,
		InsuranceSlip
	},
	data () {
		return {
			type:this.$route.params.type||''
		}
	},
	created(){
	},
	methods:{
		async validateInsuranceSlip(){
			console.log(this.type,'type')
			// 只有个人类型才需要校验投保单
			if(this.type != 'person'){
				return { fileList: [] };
			}
			
			/*获取投保单*/
			let insuranceForm = await this.$refs.insuranceSlip.val();
			if(!insuranceForm){
			    this.toast('请上传投保单','error');
				return false;
			}
			console.log(insuranceForm,'投保单')
			return insuranceForm;
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
		font-size: 25px;
		line-height: 1.8;
	}
	span.price{
		color:#FF0000;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/Confirm.vue